export { ProductDescription, ProductDescriptionComponent } from './ProductDescription';
